import { takeEvery } from 'redux-saga'
import { put, call, select } from 'redux-saga/effects'
import { checkOfflineLimitsSelector, exportsSelector, networkClosetCountSelector,
  wiredDeviceCountSelector, doorControllerCountSelector, devicesSelector } from 'selectors'
import { cameraCountSelector } from 'selectors/components'
import { createProjectAction, duplicateProjectAction } from 'actions/projectActions'
import { createCameraAction, copyCameraAction, favoriteModelAction } from 'actions/cameraActions'
import { copyMultiImagerAction } from 'actions/multiImagerActions'
import { addNetworkClosetAction, addWiredDeviceAction, duplicateWiredDeviceAction, addDoorControllerAction } from 'actions/entityActions'
import { updateUiAction } from 'actions/uiActions'
import { startExportAction } from 'actions/exportActions'
import { notifyHoneybadgerAction, reverseGeocodeLocationAction } from 'actions/applicationActions'
import { CHECK_OFFLINE_LIMITS } from 'actions/applicationActionTypes'
import determineLocationOfNewDevice from 'helpers/map/determineLocationOfNewDevice'
import { OFFLINE_DEVICE_LIMITS } from 'helpers/globals'

export function * checkOfflineLimits(action) {
  try {
    const { limitType, actionArgs } = action
    const { offline, map, isImperial, titleChanged } = yield select(checkOfflineLimitsSelector)
    let devices

    // handle device limits first
    switch (limitType) {
      case 'createCamera':
      case 'copyCamera':
      case 'copyMultiImager':
        const cameraCount = yield select(cameraCountSelector)
        if (offline && cameraCount >= OFFLINE_DEVICE_LIMITS['cameras']) return yield put(updateUiAction({ modal: 'LoginForm', deviceLimitType: 'cameras' }))

        if (limitType === 'createCamera') return yield put(createCameraAction(actionArgs ? actionArgs[0] : null))
        else if (limitType === 'copyCamera') return yield put(copyCameraAction(...actionArgs))

        return yield put(copyMultiImagerAction(...actionArgs))
      case 'addDoorController':
        const { doorControllerCount } = yield select(doorControllerCountSelector);
        ({ devices } = yield select(devicesSelector))
        if (offline && doorControllerCount >= OFFLINE_DEVICE_LIMITS['door controller']) return yield put(updateUiAction({ modal: 'LoginForm', deviceLimitType: 'door controller' }))

        const doorControllerLocation = yield call(determineLocationOfNewDevice, { map, devices, isImperial })
        if (devices.length === 0 && !titleChanged) {
          yield put(reverseGeocodeLocationAction(doorControllerLocation))
        }

        return yield put(addDoorControllerAction(doorControllerLocation))
      case 'addNetworkCloset':
        const { networkClosetCount } = yield select(networkClosetCountSelector);
        ({ devices } = yield select(devicesSelector))
        if (offline && networkClosetCount >= OFFLINE_DEVICE_LIMITS['network closet']) return yield put(updateUiAction({ modal: 'LoginForm', deviceLimitType: 'network closet' }))

        const networkClosetLocation = yield call(determineLocationOfNewDevice, { map, devices, isImperial })
        if (devices.length === 0 && !titleChanged) {
          yield put(reverseGeocodeLocationAction(networkClosetLocation))
        }

        return yield put(addNetworkClosetAction(networkClosetLocation))
      case 'addWiredDevice':
      case 'duplicateWiredDevice':
        const { wiredDeviceCount } = yield select(wiredDeviceCountSelector);
        ({ devices } = yield select(devicesSelector))
        if (offline && wiredDeviceCount >= OFFLINE_DEVICE_LIMITS['other device']) return yield put(updateUiAction({ modal: 'LoginForm', deviceLimitType: 'other device' }))

        const wiredDeviceLocation = yield call(determineLocationOfNewDevice, { map, devices, isImperial })
        if (devices.length === 0 && !titleChanged) {
          yield put(reverseGeocodeLocationAction(wiredDeviceLocation))
        }

        if (limitType === 'addWiredDevice') return yield put(addWiredDeviceAction(wiredDeviceLocation, ...actionArgs))
        return yield put(duplicateWiredDeviceAction(wiredDeviceLocation, ...actionArgs))
    }

    // handle just offline checks
    if (offline) return yield put(updateUiAction({ modal: 'LoginForm' }))

    switch (limitType) {
      case 'modal':
        return yield put(updateUiAction({ modal: actionArgs[0] }))
      case 'listProjects':
        const { exports } = yield select(exportsSelector)
        return yield put(updateUiAction({ modal: exports.length > 0 ? 'ExportRunningError' : 'ProjectList' }))
      case 'newProject':
        return yield put(createProjectAction())
      case 'duplicateProject':
        return yield put(duplicateProjectAction())
      case 'favoriteModel':
        return yield put(favoriteModelAction(...actionArgs))
      case 'export':
        return yield put(startExportAction(...actionArgs))
    }
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

/** Watch for check offline limits action, then call function */
export function * watchCheckOfflineLimits() {
  yield * takeEvery(CHECK_OFFLINE_LIMITS, checkOfflineLimits)
}



// WEBPACK FOOTER //
// ./src/sagas/checkOfflineLimitsSaga.js